export default `float de(vec3 p){ 
    vec3 size = vec3(1.); 
    vec3 d = abs(p) - size;

    return max(max(d.x, d.y), d.z);
  }

  float de(vec3 p){
    vec3 size = vec3(1.); 
    vec3 d = abs(p) - size;
    vec3 md = min(d, vec3(0.0));

    return length(max(d, vec3(0.0))) + max(max(md.x, md.y), md.z);
  }`